var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 414,
    viewBox: "0 0 423 414",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.012 76.8447V-41.493H246.451V76.8447C246.451 80.8029 249.731 84.0215 253.732 84.0215H709.997H710.497V83.5215V-86.1431C710.497 -99.7802 699.227 -110.866 685.396 -110.866H76.1142C72.1133 -110.866 68.8334 -107.648 68.8334 -103.689V188.126C68.8334 190.028 69.6292 191.81 70.98 193.14L224.207 344.068C225.617 345.456 227.426 346.179 229.394 346.179H685.449C699.279 346.179 710.549 335.093 710.549 321.456V220.664H778.988V321.456C778.988 372.206 737.062 413.5 685.501 413.5H229.447C209.129 413.5 190.122 405.735 175.866 391.647L175.866 391.646L22.6397 240.823C8.38255 226.682 0.5 207.969 0.5 188.074V-103.741C0.5 -144.864 34.4885 -178.291 76.2194 -178.291H177.512H178.012V-178.791V-365.95C178.012 -407.073 212.001 -440.5 253.732 -440.5H720.194C745.138 -440.5 768.665 -430.924 786.285 -413.523L786.286 -413.522L928.994 -272.951L929.01 -272.92L929.047 -272.848L929.105 -272.791C946.777 -255.389 956.5 -232.226 956.5 -207.672V59.3503C956.5 110.101 914.574 151.395 863.014 151.395H253.732C211.949 151.395 178.012 117.917 178.012 76.8447ZM246.898 -178.239H684.229L684.176 -178.188H685.396C736.957 -178.188 778.883 -136.894 778.883 -86.1431V83.5215V84.0215H779.383H862.909C876.739 84.0215 888.009 72.9356 888.009 59.2985V-207.724C888.009 -214.278 885.378 -220.512 880.66 -225.21L880.658 -225.212L737.892 -365.84C733.172 -370.487 726.896 -373.075 720.194 -373.075H253.679C249.678 -373.075 246.398 -369.857 246.398 -365.898V-178.739V-178.239H246.898Z",
    stroke: "url(#paint0_linear_47_15495)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_15495",
    x1: 478.5,
    y1: 4.36383,
    x2: 478.5,
    y2: 414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D8F50",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8F50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorup);
export default __webpack_public_path__ + "static/media/Vectorup.a145851c866626c700ca08fe8ce6228b.svg";
export { ForwardRef as ReactComponent };